import { Pipe, PipeTransform } from '@angular/core';
import {
  COUNTRY_CODE_NO,
  CultureKeyType,
  FALLBACK_CULTURE,
} from '@constants/app.constants';
import { CultureResource } from '@models/resources/culture.model';
import { getCultureCodeParts } from '@utils/data-utils';

@Pipe({
  name: 'culture',
  standalone: true,
})
export class CulturePipe implements PipeTransform {
  transform(
    culture: string | null | undefined,
    transformType: CulturePipeTransformType,
    cultures?: CultureResource[],
  ): string {

    if (!culture) {
      return '--';
    }
    const defaultLanguage = getCultureCodeParts(FALLBACK_CULTURE);
    const languageCode = culture.split('-')[0];
    const countryCode = culture.split('-')[1];
    switch (transformType) {
      case CulturePipeTransformType.CountryCode:
        return countryCode ?? defaultLanguage.country;
      case CulturePipeTransformType.LanguageCode:
        if (countryCode?.toUpperCase() === COUNTRY_CODE_NO) {
          return COUNTRY_CODE_NO;
        }
        return languageCode ?? defaultLanguage.language;
      case CulturePipeTransformType.CultureName:
        return cultures?.find((c) => c.cultureCode === culture)?.name ?? '--';
    }
  }
}

export enum CulturePipeTransformType {
  CountryCode,
  LanguageCode,
  CultureName,
}
